import { createSelector } from 'reselect'; 

const subscriptionPlanInfo = state =>  state;
const _subscriptionPlanPaymentStatus = state => state.checkoutTestCreation || {};

export const subscriptionPlanPaymentStatus = createSelector(
    _subscriptionPlanPaymentStatus,
    data => {
        const {
            error,
            errorInfo,
            loading,
            response,
            isFreeChallenge
        } = data;
      
        return {
            error,
            errorInfo: errorInfo && errorInfo.response && errorInfo.response.data && errorInfo.response.data.status,
            loading,
            response,
            isFreeChallenge
        }
    }
)

export const subscriptionPlansData = createSelector(
    subscriptionPlanInfo,
    state => {
        // const info = state.subscriptionPlansInfo && state.subscriptionPlansInfo.response && state.subscriptionPlansInfo.response.subscription_plans;
        //     {
        //         access_to_forum: 1
        //         access_to_leaderboard: 1
        //         access_to_library: "free+paid"
        //         access_to_performance: "None"
        //         access_to_planner: 0
        //         display_ads: 0
        //         feature_name: "BASIC"
        //         id: 1
        //         number_of_exams: 1
        //         planned_events_per_day: 0
        //         planned_tests_per_day: 0
        //         practice_tests_per_day: 5
        //         support: "None"
        //     }
           

        return {
            subscriptionPlansInfo: state.subscriptionPlansInfo && state.subscriptionPlansInfo.response && state.subscriptionPlansInfo.response.subscription_plans,
            loading: state.subscriptionPlansInfo && state.subscriptionPlansInfo.loading,
            error: state.subscriptionPlansInfo && state.subscriptionPlansInfo.error,
            errorInfo: state.subscriptionPlansInfo && state.subscriptionPlansInfo.errInfo,
        }
    }    
  )
